// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import _ from 'lodash';
import { DateTime } from 'luxon';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

const AdminStudyUserListItem = ({
  course
  , getCell
  , study
  , studyUser
  , studyRole
  , textCutoff
  , userEvents
}) => {
  const hasOnboarded = _.findIndex(userEvents, {eventAction: "onboarded"}) > -1; // need user object here
  // const sorted = _.orderBy(userEvents, [item => item.created], ['desc']);

  return (
    <tr >
      <td className="_20">
        {/* <Link className="email-text" to={`/admin/authoring/studies/${study._id}/study-users/${studyUser._id}`}>{studyUser.email}</Link> */}
        <a className="email-text" href={`${window.hubUrl}/super/groups/${study._id}/group-users/${studyUser._id}`}>{studyUser.email}</a>
      </td>
      <td className="_10" ref={getCell} data-tip data-for={studyUser._id + "_role"}>
        {studyRole ? _.startCase(studyRole.role) : 'n/a'}
        <div >
          <ReactTooltip
            aria-haspopup='true'
            className="yt-tooltip"
            id={studyUser._id + "_role"}
            place="top"
            type="dark"
          >
            <p>{studyRole ? _.startCase(studyRole.role) : 'n/a'}</p>
          </ReactTooltip>
        </div>
      </td>
      <td className="_10">{studyUser.siteNumber}</td>
      <td className="_10" ref={getCell} data-tip data-for={studyUser._id + "_courseTitle"}>
        {course && course.title ? course.title : null}
        {// if the course title is longer than the textCutoff length, show a tooltip with the full title.
          course && course.title && course.title.length > textCutoff ?
          <div className="u-pullRight">
            <ReactTooltip
              aria-haspopup='true'
              className="yt-tooltip"
              id={studyUser._id + "_courseTitle"}
              place="top"
              type="dark"
            >
              <p>{course.title}</p>
            </ReactTooltip>
          </div>
        :
          null
        }
      </td>
      <td className="_10">{DateTime.fromISO(studyUser.created).toLocaleString(DateTime.DATE_SHORT)}</td>
      <td className="_10">
        {_.startCase(studyUser.status)}
        { studyUser.status == 'deactivated' ?
          <small><br/><em>{DateTime.fromISO(studyUser.dateRevoked).toLocaleString(DateTime.DATE_SHORT)}</em></small>
          : studyUser.status == 'expired' ?
          <small><br/><em>{DateTime.fromISO(studyUser.expires).toLocaleString(DateTime.DATE_SHORT)}</em></small>
          :
          null
        }
      </td>
      {/* <td className="_10">{hasOnboarded ? <small>Onboarded</small> : null }</td> */}
      <td className="_10">{studyUser.admin ? "Admin" : studyUser.permissions.includes('view-reports') ? <small>View Reports</small> : null }</td>
      {/* <td className="_10">{sorted[0] ? sorted[0].eventAction : null } - <br/>{sorted[0] ? DateTime.fromISO(sorted[0].created).toLocaleString(DateTime.DATE_SHORT) : null }</td> */}
    </tr>
  )
}

AdminStudyUserListItem.propTypes = {
  course: PropTypes.object
  , study: PropTypes.object
  , studyUser: PropTypes.object.isRequired
  , studyRole: PropTypes.object
  , userEvents: PropTypes.array
}

AdminStudyUserListItem.defaultProps = {
  userEvents: []
}

export default withRouter(AdminStudyUserListItem);



// WEBPACK FOOTER //
// modules/studyUser/components/AdminStudyUserListItem.js.jsx